module.exports = __webpack_public_path__ + "img/checkmark.fad767c5.svg";